export enum Resources {
  Accounts = '/accounts',
  Agencies = '/agencies',
  AgencyAssociates = '/agencies/:agency_id/associates',
  Buckets = '/buckets',
  Companies = '/companies',
  Countries = '/countries',
  CroneTasks = '/tasks',
  Files = '/files',
  FileView = '/files/:file_id/view',
  Groups = '/groups',
  Permissions = '/users/:user_id/permissions',
  ProductAddons = '/products/:product_id/addons',
  ProductAttributes = '/product-attributes',
  ProductClasses = '/product-classes',
  Products = '/products',
  ProductSpecifications = '/product-specifications',
  ProductTypes = '/product-classes/:product_class_id/types',
  Progress = '/progress',
  ProposalProducts = '/proposals/:proposal_id/products',
  Proposals = '/proposals',
  Resources = '/resources',
  Roles = '/roles',
  SFTP = '/sftp',
  SFTPFiles = '/sftp/:sftp_id/files',
  SFTPListDir = '/sftp/:sftp_id/ls',
  States = '/countries/:country_id/states',
  TemplateBulkProducts = '/templates/:template_id/bulk-products',
  TemplateProducts = '/templates/:template_id/products',
  Templates = '/templates',
  Tiers = '/tiers',
  UserPasswords = '/users/:user_id/passwords',
  Users = '/users',
  VendorAssociates = '/vendors/:vendor_id/associates',
  VendorBulkProducts = '/vendors/:vendor_id/bulk-products',
  VendorProducts = '/vendors/:vendor_id/products',
  Vendors = '/vendors',
  Board = '/board',
  LE_KLE_DataPush = '/proposals/:proposal_id/legacy',
  ProposalClone = '/proposals/:proposal_id/clone',
  LegacyRedirect = '/redirects',
  JoomlaProposals = '/joomla_proposals',
  CompanyMembers = '/companies/:company_id/members',
  Enrollments = '/enrollments',
  MemberSelf = '/member',
  Dependents = '/dependents',
  NULL = '',
}
